module.exports = __webpack_public_path__ + "img/114.7.460991a1.png";